import axios from 'axios';
import { authService } from './authService';

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:42026';

export interface ApiKey {
  id: string;
  keyPrefix: string;
  name: string;
  status: 'active' | 'revoked';
  scopes: string[];
  createdBy: string;
  createdAt: string | null;
  revokedAt: string | null;
  lastUsedAt: string | null;
  totalElements: number;
  totalRequests: number;
}

export interface ApiKeyUsageRecord {
  apiKeyId: string;
  apiKeyName: string;
  keyPrefix: string;
  date: string;
  sensitiveElementsProtected: number;
  requestCount: number;
}

export interface GenerateKeyResponse {
  success: boolean;
  apiKey: {
    id: string;
    key: string;
    keyPrefix: string;
    name: string;
    scopes: string[];
  };
  message: string;
}

class ApiKeyService {
  private getAuthHeaders() {
    const token = authService.getToken();
    return token
      ? { 'x-access-token': token, 'x-pp-client-id': 'privacypal-user-portal' }
      : {};
  }

  async generateKey(name: string, scopes: string[] = ['encode', 'decode', 'batch']): Promise<GenerateKeyResponse> {
    const response = await axios.post(
      `${API_BASE_URL}/api/keys`,
      { name, scopes },
      { headers: this.getAuthHeaders() }
    );
    return response.data;
  }

  async getKeys(): Promise<ApiKey[]> {
    const response = await axios.get(`${API_BASE_URL}/api/keys`, {
      headers: this.getAuthHeaders()
    });
    return response.data?.keys || [];
  }

  async revokeKey(keyId: string): Promise<void> {
    await axios.delete(`${API_BASE_URL}/api/keys/${keyId}`, {
      headers: this.getAuthHeaders()
    });
  }

  async getUsage(days: number = 30): Promise<ApiKeyUsageRecord[]> {
    const response = await axios.get(`${API_BASE_URL}/api/keys/usage?days=${days}`, {
      headers: this.getAuthHeaders()
    });
    return response.data?.usage || [];
  }
}

export const apiKeyService = new ApiKeyService();
